// import { Component, OnInit } from '@angular/core';
// import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
//
// @Component({
//   selector: 'app-education-sop',
//   templateUrl: './education-sop.component.html',
//   standalone: true,
//   styleUrls: ['./education-sop.component.scss']
// })
// export class EducationSopComponent implements OnInit {
//   // sopHtml: SafeHtml;
//   // constructor(private sanitizer: DomSanitizer) {
//   //   const rawHtml = `PASTE SOP HTML HERE`;
//   //   this.sopHtml = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
//   // }
//   //
//   // ngOnInit(): void {
//   // }
//
//   editMode = false;
//
//   constructor() {}
//
//   ngOnInit(): void {}
//
//   toggleEdit() {
//     this.editMode = !this.editMode;
//   }
//
//
// }
//
//


// education-sop.component.ts
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'app-education-sop',
  templateUrl: './education-sop.component.html',
  styleUrls: ['./education-sop.component.scss']
})
export class EducationSopComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  @ViewChild('contentArea') contentArea!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;

  editMode = false;
  logoSrc = 'assets/logo.png'; // Your existing logo path

  constructor(private afs: AngularFirestore) {}

  // ngOnInit(): void {}

  // toggleEdit(): void {
  //   this.editMode = !this.editMode;
  // }
  sopTitle = 'Non-Formal Educational Intervention – SOP';

  // ngOnInit(): void { const savedHtml = localStorage.getItem('SOP_HTML');
  //   if (savedHtml) { setTimeout(() => { this.contentArea.nativeElement.innerHTML = savedHtml; }); } }


  ngOnInit(): void {
    this.afs
      .collection(this.env.educationSOP)
      .doc("MAIN_SOP")
      .valueChanges()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: any) => {
        if (!data) return;
        this.sopTitle = data.title;
        this.logoSrc = data.logo;

        setTimeout(() => {
          this.contentArea.nativeElement.innerHTML = data.body;
        });
      });
  }


  // toggleEdit() {
  //   if (this.editMode) {
  //     const html = this.contentArea.nativeElement.innerHTML;
  //     localStorage.setItem('SOP_HTML', html);
  //     alert('Saved successfully!');
  //   }
  //
  //   this.editMode = !this.editMode;
  // }

  // toggleEdit() {
  //   if (this.editMode) {
  //     // save ONLY body
  //     const html = this.contentArea.nativeElement.innerHTML;
  //     localStorage.setItem('SOP_BODY', html);
  //
  //     // save header separately
  //     localStorage.setItem('SOP_TITLE', this.sopTitle);
  //     localStorage.setItem('SOP_LOGO', this.logoSrc);
  //
  //     alert("Saved Successfully!");
  //   }
  //   this.editMode = !this.editMode;
  // }


  toggleEdit() {
    if (this.editMode) {
      this.saveSOP(); // save when switching from edit → view
    }

    this.editMode = !this.editMode;
  }



  saveSOP() {
    console.log("SAVE FUNCTION TRIGGERED!");

    const sopBody = this.contentArea.nativeElement.innerHTML;

    const sopData = {
      title: this.sopTitle,
      logo: this.logoSrc,
      body: sopBody,
      updatedAt: new Date(),
      createdAt: new Date()
    };

    this.afs
      .collection(this.env.educationSOP)
      .doc("MAIN_SOP")
      .set(sopData, { merge: true })
      .then(() => console.log("SAVED IN FIRESTORE"))
      .catch(err => console.error("ERROR:", err));
  }



  insertLink() {
    const url = prompt("Enter URL:");
    if (!url) return;

    const text = prompt("Enter display text:", url);
    if (!text) return;

    const linkHTML = `<a href="${url}" target="_blank">${text}</a>`;

    document.execCommand("insertHTML", false, linkHTML);
    this.contentArea.nativeElement.focus();
  }


  onTitleChange(event: any) {
    this.sopTitle = event.target.innerText;
  }


  executeCommand(command: string, value: string | null = null): void {
    document.execCommand(command, false, value || undefined);
    this.contentArea?.nativeElement.focus();
  }

  insertTable(): void {
    const rows = prompt('Number of rows:', '3');
    const cols = prompt('Number of columns:', '3');

    if (rows && cols) {
      let tableHTML = '<table class="table table-bordered black-border" style="margin: 20px 0;"><tbody>';
      for (let i = 0; i < parseInt(rows); i++) {
        tableHTML += '<tr>';
        for (let j = 0; j < parseInt(cols); j++) {
          tableHTML += '<td style="border: 1px solid black; padding: 8px;">Cell</td>';
        }
        tableHTML += '</tr>';
      }
      tableHTML += '</tbody></table>';

      document.execCommand('insertHTML', false, tableHTML);
    }
  }

  changeLogo(): void {
    if (this.editMode) {
      this.fileInput.nativeElement.click();
    }
  }

  // handleLogoChange(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   const file = input.files?.[0];
  //
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e: ProgressEvent<FileReader>) => {
  //       this.logoSrc = e.target?.result as string;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  handleLogoChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = e => {
      this.logoSrc = e.target?.result as string;
      localStorage.setItem("COUNSELLING_SOP_LOGO", this.logoSrc);
    };
    reader.readAsDataURL(file);
  }

  addTableRow(): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      alert('Please place cursor inside a table cell');
      return;
    }

    let node: Node | null = selection.anchorNode;
    let cell: HTMLTableCellElement | null = null;

    // Traverse up to find the table cell
    while (node && node !== this.contentArea?.nativeElement) {
      if (node.nodeName === 'TD' || node.nodeName === 'TH') {
        cell = node as HTMLTableCellElement;
        break;
      }
      node = node.parentNode;
    }

    if (cell) {
      const row = cell.closest('tr');
      if (row && row.parentNode) {
        const newRow = row.cloneNode(true) as HTMLTableRowElement;
        newRow.querySelectorAll('td, th').forEach((cell: Element) => {
          (cell as HTMLElement).textContent = 'New Cell';
        });
        row.parentNode.insertBefore(newRow, row.nextSibling);
      }
    } else {
      alert('Please place cursor inside a table cell');
    }
  }

  addTableColumn(): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      alert('Please place cursor inside a table cell');
      return;
    }

    let node: Node | null = selection.anchorNode;
    let cell: HTMLTableCellElement | null = null;

    // Traverse up to find the table cell
    while (node && node !== this.contentArea?.nativeElement) {
      if (node.nodeName === 'TD' || node.nodeName === 'TH') {
        cell = node as HTMLTableCellElement;
        break;
      }
      node = node.parentNode;
    }

    if (cell) {
      const cellIndex = cell.cellIndex;
      const table = cell.closest('table');

      if (table && cellIndex !== undefined) {
        const rows = table.querySelectorAll('tr');
        rows.forEach((row: Element) => {
          const tr = row as HTMLTableRowElement;
          const targetCell = tr.cells[cellIndex];
          if (targetCell) {
            const newCell = targetCell.cloneNode(false) as HTMLTableCellElement;
            newCell.textContent = 'New';
            tr.insertBefore(newCell, targetCell.nextSibling);
          }
        });
      }
    } else {
      alert('Please place cursor inside a table cell');
    }
  }


  deleteTableRow(): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      alert('Please place cursor inside a table cell');
      return;
    }

    let node: Node | null = selection.anchorNode;
    let cell: HTMLTableCellElement | null = null;

    while (node && node !== this.contentArea?.nativeElement) {
      if (node.nodeName === 'TD' || node.nodeName === 'TH') {
        cell = node as HTMLTableCellElement;
        break;
      }
      node = node.parentNode;
    }

    if (cell) {
      const row = cell.closest('tr');
      if (row && row.parentNode) {
        // Prevent deleting last row
        if (row.parentNode.children.length === 1) {
          alert('Cannot delete the only row.');
          return;
        }
        row.parentNode.removeChild(row);
      }
    } else {
      alert('Please place cursor inside a table cell');
    }
  }


  deleteTableColumn(): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      alert('Please place cursor inside a table cell');
      return;
    }

    let node: Node | null = selection.anchorNode;
    let cell: HTMLTableCellElement | null = null;

    while (node && node !== this.contentArea?.nativeElement) {
      if (node.nodeName === 'TD' || node.nodeName === 'TH') {
        cell = node as HTMLTableCellElement;
        break;
      }
      node = node.parentNode;
    }

    if (cell) {
      const cellIndex = cell.cellIndex;
      const table = cell.closest('table');

      if (table && cellIndex !== undefined) {
        const rows = table.querySelectorAll('tr');

        // Prevent deleting last column
        if ((rows[0] as HTMLTableRowElement).cells.length === 1) {
          alert('Cannot delete the only column.');
          return;
        }

        rows.forEach((row: Element) => {
          const tr = row as HTMLTableRowElement;
          if (tr.cells[cellIndex]) {
            tr.deleteCell(cellIndex);
          }
        });
      }
    } else {
      alert('Please place cursor inside a table cell');
    }
  }

  deleteTable(): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      alert('Please place cursor inside a table');
      return;
    }

    let node: Node | null = selection.anchorNode;
    let table: HTMLTableElement | null = null;

    // Traverse upward to find the table
    while (node && node !== this.contentArea?.nativeElement) {
      if (node.nodeName === 'TABLE') {
        table = node as HTMLTableElement;
        break;
      }
      node = node.parentNode;
    }

    if (table) {
      // Confirm delete
      const yes = confirm('Do you want to delete the entire table?');
      if (yes) {
        table.remove();
      }
    } else {
      alert('Please place cursor inside a table');
    }
  }


  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
